import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AddFieldModalComponent } from 'app/modules/well-header-information/pages/assets/region/add-field-modal/add-field-modal.component';
import { EditRegionModalComponent } from 'app/modules/well-header-information/pages/assets/region/edit-region-modal/edit-region-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { RegionClass } from 'app/modules/well-header-information/model/assets.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  standalone: true,
  styleUrls: ['./region.component.scss']
})
export class RegionComponent {
  public region: RegionClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }
  
  ngOnInit(): void {
   this.route.paramMap.subscribe(params => {
      let regionId = params.get('regionId');
      this.getPsc(regionId)
    });
  }

  getPsc(id: any) {
    this.wellHeaderService.getPscById(id).subscribe((res) => {
      this.region = {
        regionId: res.data.id,
        operatorId: res.data.companyId,
        name: res.data.regionShortName,
        longName: res.data.regionLongName,
        createdDate: res.data.inputDate,
        remarks: res.data.remark,
        level: 'region'
      };
    })
  }

  addFieldModal(regionDetails) {
    const dialogRef = this.dialog.open(AddFieldModalComponent, {
      data: regionDetails.regionId,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.wellHeaderService.getAssetTree().subscribe()
        this.wellHeaderService.updateParentsNode([this.region.operatorId,this.region.regionId])
      }
    });
  }

  editRegionModal(companyData: any) {
    const dialogRef = this.dialog.open(EditRegionModalComponent, {
      data: companyData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getPsc(companyData.regionId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
